import clsx from 'clsx'

type BookingStepProps = React.PropsWithChildren<React.HTMLProps<HTMLDivElement> & {}>

export function BookingStep({ children, className, ...props }: BookingStepProps) {
  return (
    <div className={clsx('relative sm:w-[620px] sm:bg-white sm:shadow-sm sm:rounded-md px-4 py-6 sm:px-0', className)} {...props}>
      {children}
    </div>
  )
}

function BookingStepContent({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={clsx('sm:px-7', className)}>{children}</div>
}

function BookingStepTitle({ children, className }: React.PropsWithChildren<React.HTMLProps<HTMLHeadingElement> & {}>) {
  return (
    <h2 className={clsx('sm:flex sm:items-center sm:min-h-[60px] sm:border-l-4 border-primary mb-4 sm:pl-6 text-lg sm:text-2xl font-bold', className)}>
      {children}
    </h2>
  )
}

BookingStep.Content = BookingStepContent
BookingStep.Title = BookingStepTitle
